export interface ErrorPattern {
    pattern: string | RegExp;
    key: string;
}

export const ERROR_412_EXACT_MAPPING = new Map<string, string>([
    [
        'Cannot update application status because the requested state transition is not valid.',
        'application-errors.invalid-status-transition'
    ],
    ['No award committee meeting is assigned to the application.', 'application-errors.award-committee-not-assigned'],
    ['No committee protocol is assigned to the application.', 'application-errors.committee-protocol-not-assigned']
]);

export const ERROR_412_PATTERNS: ErrorPattern[] = [
    {
        pattern: /User with gid="[^"]+" is not allowed to \w+ application/i,
        key: 'application-errors.user-not-allowed-action'
    },
    {
        pattern: /Application with id="[^"]+" cannot be submitted due to files statuses or extensions./i,
        key: 'application-errors.submission-invalid-files'
    }
];

export const ERROR_FALLBACK_MAPPING = new Map<number, string>([
    [400, 'generic-errors.bad_request'],
    [401, 'generic-errors.unauthorized'],
    [403, 'generic-errors.forbidden'],
    [404, 'generic-errors.not_found'],
    [412, 'generic-errors.precondition_failed'],
    [500, 'generic-errors.internal_server_error'],
    [503, 'generic-errors.service_unavailable']
]);
